import { Component, Prop, ProvideReactive, Vue } from 'vue-property-decorator';

import Pin from '@/types/FilterTree/Pin';


import ListItem from '@/types/fields/ListItem';
import FilterT from '@/types/FilterTree/FilterT';
import locales from '../locales/Pins.json'
import PinTypeEnum from '@/enums/PinTypeEnum';

/** Classe de base des composants de gestion de pins */
@Component({
	i18n: {messages: locales}
})
export default class BasePins extends Vue {
	/** Desactive l'interactivité du composant */
	@Prop({ default: false})
	public Disable!: boolean;

	/** Couleur de variant à appliquer sur le composant */
	@Prop({ default: () => "secondary"})
	@ProvideReactive()
	public Variant!: string;

	/** Permet de definir un filtre sur les pins afin de limiter leur affichage */
	@Prop({ default: undefined })
	public FilterPins!: (pin: Pin) => boolean;

	/** Liste des types de Pin pour les filtres par propriétés */
	@Prop({default: () => []})
	public PropertiesFilterPinTypes!: PinTypeEnum[];

	/** Nom du store Vuex persistant l'arborescence */
	@Prop()
	public FilterTreeStore!: string;

	/** Indique si l'on doit filtrer les options de type d'objet proposé par le property filter */
	protected propertiesFilterObjectTypes: string[] | undefined;

	/** Indique si le bouton de filtre par propriété est visible ou non */
	protected get propertiesFilterVisible(): boolean {
		return this.$store.getters[this.FilterTreeStore + '/PropertiesFilterVisible'];
	}

	protected set propertiesFilterVisible(value: boolean) {
		this.$store.dispatch(this.FilterTreeStore + '/SetPropertiesFilterVisible', value)
	}

	/** filtre chargé pour l'instance d'arborescence en cours */
	protected filter():  FilterT {
		return this.$store.getters[this.FilterTreeStore + '/GetFilter'];
	}

	/** grouping chargé pour l'instance d'arborescence en cours */
	protected grouping():  FilterT {
		return this.$store.getters[this.FilterTreeStore + '/GetGrouping'];
	}

	/** Pin sélectionnée pour la modification */
	protected selectedPin : Pin = {} as any;

	/** Liste des 5 derniers filtres enregistrés */
	protected lastFilters(): ListItem[] {
		return this.$store.getters[this.FilterTreeStore + '/GetFilters'](5);
	}

	protected removeFilter() {
		this.$store.dispatch(this.FilterTreeStore + "/RemoveFilter");
	}

	protected removeGrouping() {
		this.$store.dispatch(this.FilterTreeStore + "/RemoveGrouping");
	}

	protected toggleIncluded(pin: Pin) {
		this.$store.dispatch(this.FilterTreeStore + "/ToggleIncluded", pin);
	}

	protected removePin(pin: Pin) {
		this.$store.dispatch(this.FilterTreeStore + "/RemovePin", pin);

		//this.checkHeightOverflowing();
	}

	protected loadFilter(id: number) {
		let filter: FilterT = { Id: id.toString(), Name: "", Remark: "", Color: "", Pins: [] } as FilterT;
		this.$store.dispatch(this.FilterTreeStore + "/LoadFilter", { filter: filter });
	}

	/**
	 * Permet la suppression d'un filtre
	 * @param id identitfiant du filtre à supprimer
	 */
	protected async deleteFilter(id: number){
		await this.$store.dispatch(this.FilterTreeStore + "/Delete", id).then( async () => {
			// Rechargement de tous les filtres post-suppression
			await this.$store.dispatch(this.FilterTreeStore + "/LoadFilters");

			// si identifiant supprimé correspond à celui appliqué, on enleve le filtre
			if (Number(this.filter().Id) == id) {
				this.removeFilter();
			}
		});
	}
}